<style scoped>
.card-title > ul:nth-child(2) {
  position: absolute;
  left: 1.5em;
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  top: calc(1.5em + 24px);
  z-index: 1;
  margin-top: 1em;
  border: solid 1px;
  opacity: 1;
  border-radius: 0.5em;
  overflow: hidden;
  transition: transform 200ms;
  transform-origin: top;
  background-color: white;
}
.card-title > ul:nth-child(2).collapse {
  transform: scaleY(0);
}
.card-title > ul:nth-child(2) > li {
  padding: 1em 3em 1em 1em;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}
.card-title > ul:nth-child(2) > li:hover {
  background-color: var(--light-blue);
}
.space svg > circle:nth-child(2) {
  transition: stroke-dashoffset 2s 100ms;
}
</style>
<template>
  <div class="dashboard-info" ref="dashboardInfo">
    <div class="contenedor-info">
      <div class="space">
        <svg width="350" height="175">
          <circle class="track" cx="175" cy="175" r="140" stroke="var(--light-blue)" stroke-width="45" fill="none"></circle>
          <circle class="progress" cx="175" cy="175" r="140" :stroke="occupiedSpace === 1 ? 'red' : 'var(--blue)'" stroke-width="45" fill="none" :stroke-dasharray="Math.PI*140">
            <animate attributeName="stroke-dashoffset" :values="-Math.PI*140*occupiedSpace"/>
          </circle>
          <text x="50%" y="75%" dominant-baseline="middle" text-anchor="middle" style="font-weight: 600; font-size: 48px;">{{ availableSpace }}%</text>
          <text x="50%" y="95%" dominant-baseline="middle" text-anchor="middle" style="font-size: 11px;">{{ $t('info.availableSpace') }} {{ spaceAvailableString }}</text>
        </svg>
      </div>
      <div class="contenedor-cards">
        <div>
          <div class="card-title" style="position: relative;">
            <h2 style="display: flex; align-items: center; gap: 10px;">{{ title }}&nbsp;&nbsp;<chevron-down-icon @click.stop="toggleOptions" style="cursor: pointer; align-items: center;"></chevron-down-icon></h2>
            <ul class="collapse" ref="toggler">
              <li @click.stop="changeOption('sessions')"><user-icon/> {{ $t('info.sessions') }}</li>
              <li v-if="permissionsBackup" @click.stop="changeOption('backups')"><copy-icon/> {{ $t('sidebar.backups') }}</li>
              <li v-if="!isFreePlan" @click.stop="changeOption('logs')"><book-open-icon/> {{ $t('info.logs') }}</li>
            </ul>
<!-- BOTONES -->
            <div v-show="option === 'sessions'" class="botones">
              <button :aria-label="$t('settings.openSessions')" :title="$t('settings.openSessions')" id="open" :class="[sessions === 'open' ? 'active' : 'no-active']" @click="changeSessions('open')">
                {{ $t('settings.openSessions') }}
              </button>
              <button :aria-label="$t('settings.closedSessions')" :title="$t('settings.closedSessions')" id="close" :class="[sessions === 'close' ? 'active' : 'no-active']" @click="changeSessions('close')">
                {{ $t('settings.closedSessions') }}
              </button>
            </div>
            <div v-if="permissionsBackup" v-show="option === 'backups'" class="botones">
              <button :aria-label="$t('info.nextSnapshots')" :title="$t('info.nextSnapshots')" id="next" :class="[snapshots === 'next' ? 'active' : 'no-active']" @click="changeSnapshots('next')">
                {{ $t('info.nextSnapshots') }}
              </button>
              <button :aria-label="$t('info.lastSnapshots')" :title="$t('info.lastSnapshots')" id="last" :class="[snapshots === 'last' ? 'active' : 'no-active']" @click="changeSnapshots('last')">
                {{ $t('info.lastSnapshots') }}
              </button>
            </div>
            <div v-if="!isFreePlan" v-show="option === 'logs'" class="botones" style="display: flex; gap: 1em; align-items: center;">
              <span v-if="logReloadTime">{{ $t('info.lastLoadTime') + ': ' + new Date(logReloadTime).toLocaleTimeString() }}</span>
              <refresh-cw-icon v-if="logReloadTime" @click="reloadLogs" style="cursor: pointer; color: var(--blue);"></refresh-cw-icon>
            </div>
<!-- BOTONES -->
          </div>
<!-- CONTENIDO -->
          <div v-show="option === 'sessions'" class="card">
            <div class="card-content">
              <listing-active-sessions v-if="sessions === 'open'" class="false"></listing-active-sessions>
              <listing-closed-sessions v-else class="false"></listing-closed-sessions>
            </div>
          </div>
          <div v-show="option === 'backups'" class="card">
            <div class="card-content">
              <listing-next v-if="snapshots === 'next'" :class="{ multiple }"></listing-next>
              <listing-last v-else :class="{ multiple }"></listing-last>
            </div>
          </div>
          <div v-show="option === 'logs'" class="card">
            <div class="card-content">
              <listing-logs :reloadTime="logReloadTime" @reload="reloadLogs"></listing-logs>
            </div>
          </div>
<!-- CONTENIDO -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { files as api } from '@/api';
import ListingActiveSessions from '@/components/sessions/ListingActiveSessions.vue';
import ListingClosedSessions from '@/components/sessions/ListingClosedSessions.vue';
import ListingNext from '@/components/backups/ListingNext.vue';
import ListingLast from '@/components/backups/ListingLast.vue';
import ListingLogs from '@/components/logs/ListingLogs.vue';
import filesize from 'filesize';
import i18n from '@/i18n';
import moment from 'moment';
import { BookOpenIcon, ChevronDownIcon, CopyIcon, RefreshCwIcon, UserIcon } from 'vue-feather-icons';

export default {
  name: 'settings',
  components: {
    ListingNext,
    ListingLast,
    ListingActiveSessions,
    ListingClosedSessions,
    ListingLogs,
    ChevronDownIcon,
    RefreshCwIcon,
    BookOpenIcon,
    CopyIcon,
    UserIcon
  },
  data: function () {
    return {
      password: '',
      passwordConf: '',
      locale: '',
      snapshots: 'next',
      sessions: 'open',
      logReloadTime: null,
      option: 'sessions',
    };
  },
  computed: {
    ...mapState([
      'req',
      'user',
      'reload',
      'multiple',
      'loading',
      'accountInfo',
    ]),
    ...mapGetters([
      'isFreePlan',
    ]),
    title() {
      switch (this.option) {
        case 'backups':
          return this.$t('sidebar.backups');
        case 'logs':
          return this.$t('info.logs');
        case 'sessions':
        default:
          return this.$t('info.sessions');
      }
    },
    passwordClass () {
      const baseClass = 'input input--block';

      if (this.password === '' && this.passwordConf === '') {
        return baseClass;
      }

      if (this.password === this.passwordConf) {
        return `${baseClass} input--green`;
      }

      return `${baseClass} input--red`;
    },
    occupiedSpace() {
      if (this.accountInfo.tstorage > this.accountInfo.ustorage) {
          return (this.accountInfo.ustorage/this.accountInfo.tstorage).toFixed(2);
        } else {
          return 1;
        }
    },
    availableSpace() {
      if (this.accountInfo.tstorage > this.accountInfo.ustorage) {
        return ((this.accountInfo.ustorage/this.accountInfo.tstorage)*100).toFixed(2);
      } else {
        return 100;
      }
    },
    spaceAvailableString () {
      if (!this.accountInfo.tstorage)
      {
          return this.$t('info.loading');
      }

      if (this.accountInfo.tstorage > this.accountInfo.ustorage)
      {
          return this.$t('info.availableSpaceInfo', { available: filesize(this.accountInfo.ustorage), total: filesize(this.accountInfo.tstorage)});
      }

      return this.$t('info.exhausted', { available: filesize(this.accountInfo.tstorage), total: filesize(this.accountInfo.tstorage)});
    },
    statusString() {
      if (!this.accountInfo.pmethod) {
          let currentTime = Date.now();
          let renewTime = this.accountInfo.rtime * 1000;
          let rtimeString = moment(renewTime).format('DD/MM/YYYY');
          if (currentTime > (renewTime + 86400000)) // Expired more than one day ago
          {
              return '<font color=\'red\'>' + i18n.t('info.accountExpired', {'0': rtimeString, '1': '<a href=\'/profile/invoicing/plans\' style=\'color: #2B5597;\'>', '2': '</a>'}) + '</font>';
          }
          else if (currentTime + 432000000 > renewTime) // Will expire in less than 5 days
          {
              return '<font color=\'brown\'>' + i18n.t('info.accountAboutToExpire', {'0': rtimeString, '1': '<a href=\'/profile/invoicing/plans\' style=\'color: #2B5597;\'>', '2': '</a>'}) + '</font>';
          }
          else
          {
            return i18n.t('info.correct');
          }
      } else {
        return i18n.t('info.correct');
      }
    },
    isMobile () {
      return window.innerWidth <= 768;
    },
    permissionsBackup () {
      return (this.accountInfo.features & Module.FeatureType.FEATURE_BACKUP.value);
    },
  },
  created () {
    this.locale = this.user.locale;
    let thisComponent = this;
    let JavaEventListenerClass = Module.EventListener.extend('EventListener', {
      onEvent: function(event) {
        if (event.type == Module.EventType.NEW_NODES.value) {
          let node = event.node;
          if (node && (node.type == Module.NodeType.SNAPSHOT.value
            || node.type == Module.NodeType.BACKUP.value
            || node.type == Module.NodeType.DEVICE.value)) {
            thisComponent.fetchBackupsData();
          }
        } else if (event.type == Module.EventType.DELETED_NODE.value) {   
          thisComponent.fetchBackupsData();
        } else if (event.type == Module.EventType.FULL_RELOAD.value) {
          thisComponent.fetchBackupsData();
        } else if (event.type == Module.EventType.UPDATED_NODE.value) {
          let node = event.node;
          if (node && node.type == Module.NodeType.BACKUP.value) {
            thisComponent.fetchBackupsData();
          }
        }
      }
    });

    this.interfaceObject = new JavaEventListenerClass();
    ibb.addEventListener(this.interfaceObject);
  },
  async mounted() {
    try {
      let action = await ibb.getSessionInfo();
      if (action.error.type) {
        this.$showError('Error getting session info: ' +  action.error.type);
        return;
      }

      this.$store.commit('updateActiveSessionHandle', action.nodeHandle);
      this.$store.commit('updateActiveSessions', action.activeSessions, action.nodeHandle);
      this.$store.commit('updateInactiveSessions', action.inactiveSessions);
    } catch (e) {
      this.$showError(e);
    }
    this.$refs.dashboardInfo.addEventListener('click', this.onOutsideClick);
  },
  watch: {
    accountInfo(accountInfo) {
      if (!accountInfo.credit) {
        this.$router.go();
        return;
      }
    }
  },
  beforeDestroy () {
    ibb.removeEventListener(this.interfaceObject);
    this.$refs.dashboardInfo.removeEventListener('click', this.onOutsideClick);
  },
  destroyed () {
    this.$store.commit('updateNextSnapshots', {});
    this.$store.commit('updateLastSnapshots', {});
  },
  methods: {
    ...mapMutations([ 'updateUser', 'setLoading' ]),
    onOutsideClick() {
      this.$refs.toggler.classList.add('collapse');
    },
    toggleOptions() {
      this.$refs.toggler.classList.toggle('collapse');
    },
    async changeOption(option) {
      if (option === 'backups') {
        await this.fetchBackupsData();
      }
      this.toggleOptions();
      this.option = option;
    },
    reloadLogs() {
      this.logReloadTime = Date.now();
    },
    changeSnapshots (type) {
      if (type === 'next') {
        this.snapshots = 'next';
      } else {
        this.snapshots = 'last';
      }
    },
    changeSessions (type) {
      if (type === 'open') {
        this.sessions = 'open';
      } else {
        this.sessions = 'close';
      }
    },
    async fetchBackupsData () {
      this.setLoading(true);
      await Promise.all([
        api.getNextSnapshots(),
        api.getLastSnapshots(),
      ]).then(results => {
        this.$store.commit('updateNextSnapshots', results[0]);
        this.$store.commit('updateLastSnapshots', results[1]);
      }).catch(error => {
        this.error = error;
      }).finally(() => {
        this.setLoading(false);
      });
    },
    async updateSuscription (event) {
      event.preventDefault();
    },
  }
};
</script>
